// TODO: add the Frame component to the image when it's available

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-feed',
  styleUrl: 'feed.css',
  shadow: true,
})
export class Feed {
  @Prop() showcalendar: boolean = true;
  @Prop() month: string = "MMM";
  @Prop() day: string = "DD";
  @Prop() year: string = "YYYY";
  @Prop() headinglink: string = "#";
  @Prop() heading: string = "";
  @Prop() description: string = "";
  @Prop() shownewsdate: boolean = true;

  render() {
    const calendarshow = this.showcalendar ? <div class="caledar-dates"><span class="calendar-content"><span class="month">{this.month.substring(0,3)}</span><span class="day">{this.day}</span><span class="year">{this.year}</span></span></div> : <div></div>;
    const newsarticledate = this.shownewsdate ? <div class="news-article-date">{this.month} {this.day}, {this.year}</div> : <div></div>;

    return (
        <div class="calendar-content">
          <div class="calendar-row">
            {calendarshow}
            <div class="calendar-heading-descr">
              <div class="calendar-heading">
                <a href={this.headinglink}>{this.heading}</a>
                {newsarticledate}
              </div>
              <div class="calendar-descr">{this.description}</div>
            </div>
          </div>
        </div>
    ); 
  }
}
